import { render } from "./WorkOrderRecentWidget.vue?vue&type=template&id=0ead5ea6"
import script from "./WorkOrderRecentWidget.vue?vue&type=script&lang=js"
export * from "./WorkOrderRecentWidget.vue?vue&type=script&lang=js"

import "./WorkOrderRecentWidget.vue?vue&type=style&index=0&id=0ead5ea6&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__